export enum PageSizeEnum {
    twentyFive  = 25,
    fifty       = 50,
    oneHundred  = 100,
    twoHundred  = 200,
    twoFifty    = 250
}
